<style lang="scss">
.cancel_account {
  label {
    @apply block mx-4 mt-8;
  }
  input {
    @apply mr-2 transform scale-125;
  }
  p, strong {
    text-transform: initial !important;
  }
  strong {
    @apply text-red pb-2;
  }
  p {
    @apply block mt-2 ml-6 w-full;
  }
}
</style>

<template>
<main>
  <form class="cancel_account">
    <h3>Desativar / cancelar conta</h3>
    <label for="cancel_account" class="clickable" @click.prevent="permitNull(1)">
      <input @click.stop="permitNull(1)" :checked="cancellationType === 1" v-model="cancellationType" :value="1" type="radio" id="cancel_account" />
      <strong>Quero cancelar minha conta</strong>
      <p>Sua conta será cancelada e você não poderá mais acessar a plataforma.</p>
    </label>
    <button type="button" @click="$router.push({name: 'DoctorUserCancelAccount'})" :disabled="!cancellationType" class="btn btn-blue">Prosseguir</button>
  </form>
</main>
</template>

<script>
export default {
  data () {
    return {
      confirmActive: false,
      cancellationType: 0
    }
  },
  methods: {
    permitNull (v) {
      this.cancellationType = this.cancellationType === v ? null : v
    }
  }
}
</script>
